import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(5),
  },
  extraTextContainer: {
    display: "flex",
    height: "100%",
    alignItems: "center",
    margin: "0px -12px",
  },
  popOver: {
    minHeight: theme.spacing(48),
    minWidth: theme.spacing(144),
    backgroundColor: theme.palette.secondary.tint90,
    border: `1px solid ${theme.palette.secondary.tint60}`,
    borderRadius: theme.spacing(4),
    boxShadow:
      "0 20px 30px 0 rgba(0, 0, 0, 0.1), 0 30px 30px 0 rgba(0, 0, 0, 0.1)",
    color: theme.palette.secondary.tint15,
    direction: "ltr",
    overflow: "hidden",
    padding: theme.spacing(6),
  },
  popOverContainer: {
    marginTop: -theme.spacing(10),
    marginRight: -theme.spacing(5),
  },
  icon: {
    cursor: "pointer",
    margin: theme.spacing(0, 2),
  },
  howToDeal: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  switchBtn: {
    height: theme.spacing(8),
    borderRadius: theme.spacing(2),
    "& .MuiToggleButton-root": {
      color: theme.palette.secondary.tint60,
      fontSize: theme.fontSize["10"],
      backgroundColor: theme.palette.background.main,
      "&:hover": {
        filter: "brightness(95%)",
      },
    },
    "& .MuiToggleButton-root.Mui-selected": {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.white.main,
      "&:hover": {
        filter: "brightness(120%)",
      },
    },
  },
}));
